import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { Course } from '@tanzspass/shared';
import { School } from '@tanzspass/shared';
import { CourseService } from '../../services/course.service';
import { SchoolService } from '../../services/school.service';

@Component({
  selector: 'ts-course-featured',
  templateUrl: './course-featured.component.html',
  styleUrls: ['./course-featured.component.css'],
  imports: [NgIf, NgFor, RouterLink, MatIcon, MatTooltip],
})
export class CourseFeaturedComponent implements OnInit {
  public school = new School();
  public courses: Course[] = [];

  constructor(
    private schoolSrv: SchoolService,
    private courseSrv: CourseService,
  ) {}

  ngOnInit() {
    this.schoolSrv.current().subscribe((school) => {
      this.school = school;
      this.courseSrv.featuredCourses(school.id).subscribe((courses) => {
        this.courses = courses;
      });
    });
  }
}
